const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://basetaosheet.club';
const LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png';

const SITE_NAME = 'BasetaoSheet';
const SITE_DESCRIPTION =
  'The most trusted independent resource hub for Basetao Spreadsheet guides, reviews, product categories, shipping information, and expert shopping strategies.';

const organization = {
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: {
    '@type': 'ImageObject',
    url: LOGO_URL,
  },
};

export interface ArticleSchemaInput {
  title: string;
  description: string;
  image?: string;
  datePublished: string;
  dateModified?: string;
  path: string;
}

export function buildWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_URL,
    description: SITE_DESCRIPTION,
    publisher: organization,
  };
}

export function buildArticleSchema(input: ArticleSchemaInput) {
  const schema: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: input.title,
    description: input.description,
    author: {
      '@type': 'Organization',
      name: 'BasetaoSheet Editorial Team',
      url: SITE_URL,
    },
    publisher: organization,
    datePublished: input.datePublished,
    dateModified: input.dateModified || input.datePublished,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}${input.path}`,
    },
  };

  if (input.image) {
    schema.image = input.image;
  }

  return schema;
}